import { useEffect } from "react";

/**
 * Keeps fetching pages of an infinite query until the content overflows the
 * viewport (or the query runs out of pages).
 *
 * react-infinite-scroll-component only fetches on a window scroll event, so if
 * the loaded pages are too short to scroll — a tall screen, a small page size —
 * the user can't trigger the next page and the loader hangs.
 *
 * Re-checks per loaded page (not per item) so an empty page still triggers the
 * next check. Pass `enabled: false` for a query the page isn't currently showing.
 */
export function useFillViewport(infiniteQuery, enabled = true) {
  const { hasNextPage, isFetchingNextPage, fetchNextPage } = infiniteQuery;
  const pageCount = infiniteQuery.data?.pages.length ?? 0;

  useEffect(() => {
    if (!enabled || !hasNextPage || isFetchingNextPage) return;
    if (document.documentElement.scrollHeight <= window.innerHeight) {
      fetchNextPage();
    }
  }, [enabled, pageCount, hasNextPage, isFetchingNextPage, fetchNextPage]);
}
